import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { ArrowRight } from "lucide-react";
import { useAuth } from "@/context/AuthContext";
import { formatApiError } from "@/lib/api";

export default function StaffLogin() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(email, password);
      toast.success("Welcome back!");
      nav("/staff");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login failed");
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "w-full bg-zinc-900 border border-zinc-800 px-4 py-3 text-white focus:outline-none focus:ring-2 focus:ring-yellow-500 transition-shadow duration-150";

  return (
    <div className="min-h-screen bg-[#09090b] flex items-center justify-center px-6">
      <div className="w-full max-w-md">
        <div className="flex justify-center mb-2">
          <span className="bg-white rounded-md px-5 py-3 inline-flex">
            <img src="/jd-logo.png" alt="J&D Truck Repair" className="h-16 w-auto" />
          </span>
        </div>
        <p className="text-center text-zinc-500 text-sm mb-8">Sign in to the operations portal</p>
        <form onSubmit={submit} className="border border-zinc-800 bg-zinc-950 p-8 space-y-5">
          <div>
            <label className="text-xs font-bold uppercase tracking-wide text-zinc-400 block mb-2">Email</label>
            <input type="email" required value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} data-testid="login-email" />
          </div>
          <div>
            <label className="text-xs font-bold uppercase tracking-wide text-zinc-400 block mb-2">Password</label>
            <input type="password" required value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password" />
          </div>
          <button disabled={loading} data-testid="login-submit"
            className="w-full bg-yellow-500 text-black font-bold uppercase px-8 py-3 flex items-center justify-center gap-2 hover:bg-yellow-300 transition-colors duration-150 disabled:opacity-60">
            {loading ? "Signing in…" : <>Sign In <ArrowRight size={18} /></>}
          </button>
        </form>
      </div>
    </div>
  );
}
